import { SendGroupData } from './entities';

export const MARKET_ALERTS_LIST: SendGroupData[] = [
  {
    description: 'No alerts',
    id: 0,
    name: 'Off',
    status: 1,
  },
  {
    description: '',
    id: 1,
    name: 'Top Stories (4 a day)',
    status: 1,
  },
  {
    description: '',
    id: 2,
    name: 'Hot, Exclusive, Top Stories (5 - 10 a day)',
    status: 1,
  },
  {
    description: '',
    id: 3,
    name: 'Micro, Editorial, Hot, Exclusive, Top (10 - 30 a day)',
    status: 1,
  },
  {
    description: '',
    id: 4,
    name: 'Anonymous',
    status: 1,
  },
];
